import presetWeb from 'fela-preset-web';
import beautifier from 'fela-beautifier';
import { getMediaQueryOrder } from './mediaQuery';

const isSafeClassName = (cls: string) =>
  cls.indexOf('ad') === -1 && cls !== 'fa' && cls !== 'dm' && cls !== 'js';

const config: any = {
  filterClassName: isSafeClassName,
  plugins: [...presetWeb],
  mediaQueryOrder: getMediaQueryOrder(),
  devMode: false,
};

if (process.env.NODE_ENV !== 'production') {
  config.enhancers = [beautifier()];
}

export default config;
